import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'

export const formFilterFiles: {
   input?: InputBuildProps
   select?: SelectBuildProps
   layout?: any
}[] = [
      {
         select: {
            id: 'ufContrato',
            label: 'UF do contrato:',
            options: [
               { text: 'PR', value: 'PR' },
               { text: 'ES', value: 'ES' }
            ],
            required: true
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
         }
      },
      {
         input: {
            id: 'cnpjAgenteFinanceiro',
            label: 'CNPJ Agente Financeiro',
            maskReplace: 'cnpj',
            required: true
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
         }
      },
      {
         input: {
            id: 'numeroContrato',
            label: 'N° Contrato',
            required: true
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
         }
      },
      {
         input: {
            id: 'chassi',
            label: 'N° Chassi',
            required: true
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
         }
      },
      {
         input: {
            id: 'numeroAditivo',
            label: 'N° Aditivo'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
         }
      }
   ]